module.exports = __webpack_public_path__ + "img/nature2.1d69fbe5.jpg";